(() => {
  function initialize(scope) {
    for (const root of scope.querySelectorAll('[data-product-gallery]')) {
      if (root.dataset.galleryReady) continue;
      root.dataset.galleryReady = 'true';
      const slides = [...root.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
      const frame = root.querySelector('[data-gallery-frame]');
      const status = root.querySelector('[data-gallery-status]');
      if (!slides.length || !frame) continue;
      let current = 0;
      const interactive = target => target.closest('video,iframe,model-viewer,input,select,textarea,a,[contenteditable="true"]');
      function show(index) {
        const next = (index + slides.length) % slides.length;
        if (next !== current) {
          for (const video of slides[current].querySelectorAll('video')) video.pause();
          // Reload a departing embed to stop playback without requiring a provider SDK.
          for (const iframe of slides[current].querySelectorAll('iframe')) { const src = iframe.getAttribute('src'); if (src) iframe.setAttribute('src',src); }
          for (const model of slides[current].querySelectorAll('model-viewer')) model.pause?.();
        }
        current = next;
        slides.forEach((slide,i) => { slide.hidden = i !== current; slide.toggleAttribute('inert',i !== current); });
        thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===current)));
        const caption = slides[current].dataset.galleryCaption;
        if (status) status.textContent = `${current+1} / ${slides.length}${caption?` · ${caption}`:''}`;
        const thumb = thumbs[current];
        if (thumb) { const rail = thumb.parentElement; if (thumb.offsetLeft < rail.scrollLeft || thumb.offsetLeft+thumb.offsetWidth > rail.scrollLeft+rail.clientWidth) rail.scrollLeft = thumb.offsetLeft - rail.clientWidth/2 + thumb.offsetWidth/2; }
      }
      root.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(current-1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(current+1));
      thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>show(index)));
      root.addEventListener('keydown',event=>{
        if (interactive(event.target) || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key==='ArrowLeft' || event.key==='ArrowRight') { event.preventDefault(); show(current+(event.key==='ArrowRight'?1:-1)); }
      });
      let start = null;
      frame.addEventListener('touchstart',event=>{ start = !interactive(event.target) && !event.target.closest('button') && event.touches.length===1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY}:null; },{passive:true});
      frame.addEventListener('touchend',event=>{ if (!start) return; const touch = event.changedTouches[0]; const dx = touch.clientX-start.x; const dy = touch.clientY-start.y; start=null; if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.5) show(current+(dx<0?1:-1)); },{passive:true});
      frame.addEventListener('touchcancel',()=>{start=null;},{passive:true});
      show(0);
    }
  }
  initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
